<template>
  <div class="Detail-container">
    <div class="back-btn" @click="$router.back()">&#60; 返回</div>
    <promptMessage :type="data.status" :date="data.update_time" v-if="Number(data.status)!==3"></promptMessage>
    <div class="detail-content">
      <div class="row">
        <div class="label">需求标题</div>
        <div class="value">{{ data.title }}</div>
      </div>
      <div class="row" v-if="type !== 1">
        <div class="label">需求ID</div>
        <div class="value">{{ data.id }}</div>
      </div>
      <div class="row">
        <div class="label">发布者</div>
        <div class="value">{{ data.user_id }}</div>
      </div>

      <div class="row">
        <div class="label">发布时间</div>
        <div class="value">{{ formatDate(data.update_time) }}</div>
      </div>
      <div class="row">
        <div class="label">状态</div>
        <div v-if="data.status === '1'" class="value">草稿</div>
        <div v-if="data.status === '2'" class="value">待审核</div>
        <div v-if="data.status === '3'" class="value">已发布</div>
        <div v-if="data.status === '4'" class="value">已驳回</div>
        <div v-if="data.status === '5'" class="value">已完成</div>
        <div v-if="data.status === '6'" class="value">已下架</div>
      </div>
      <div class="row">
        <div class="label">行业分类</div>
        <div class="value">
          <span class="industry-tag">{{ data.tags[0] }}</span>
        </div>
      </div>
      <div class="row">
        <div class="label">附件</div>
        <div class="value">
          <div class="attachment-box">
            <img
              class="file-icon"
              src="https://img.icons8.com/ios-filled/50/000000/ms-word.png"
              alt="Word文件"
            />
            <div class="file-info">
              <div class="file-name">{{getFileName()}}</div>
              <div class="file-size">大小：7MB</div>
            </div>
            <a class="download-link" :href="data.attachment_url" download
              >附件下载</a
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="label">需求描述</div>
        <div class="value desc">
          {{ data.description }}
        </div>
      </div>
    </div>
    <div class="btn-group" v-if="type !== 2">
      <div
        class="Button1"
        v-if="type == 3 && data.status === '2'"
        @click="createDemand"
      >
        编辑并创建正式需求
      </div>
      <div
        class="Button Back"
        v-if="type == 1 && data.status !== '2' && data.status !== '3'"
        @click="SetDataOne"
      >
        编辑
      </div>
      <div
        class="Button Back"
        @click="Shelves(data)"
        v-if="
          type == 1 &&
          data.status !== '4' &&
          data.status !== '5' &&
          data.status !== '6' &&
          data.status !== '1'
        "
      >
        下架
      </div>
      <div
        class="Button success"
        @click="hanleclick"
        v-if="type == 1 && data.status !== '2' && data.status !== '3'"
      >
        发布需求
      </div>
      <div class="Button Back" v-if="type == 1" @click="DelOne(data)">删除</div>
      <div class="Button Back" @click="Reject()" v-if="type == 3 && data.status === '2'">
        驳回
      </div>
      <div @click="Shelves(data)" class="Button Back" v-if="type == 3 && (data.status === '2' || data.status === '3') && data.roleType==='MyPost'">
        下架
      </div>
      <div @click="Success(data)" class="Button Back" v-if="type == 3 && data.status === '3' && data.roleType==='MyPost'">
        已交付
      </div>
      <div @click="DelOne(data)" class="Button Del" type="danger" v-if="type == 3">删除</div>
    </div>
    <DiaLog
      :visible.sync="isDel"
      title="确认发布需求"
      :type="1"
      content="提交发布后, 你的需求将会被平台审核, 审核通过后将正式发布."
      @confirm="hanleOk"
    >
    </DiaLog>
    <DiaLog
      :visible.sync="isReject"
      title="驳回需求"
      :type="3"
      content="请填写驳回理由,理由会反馈给需求发起方."
      @confirm="RejectOk"
    >
    </DiaLog>
    <DiaLog
      :visible.sync="isDel2"
      title="确认删除需求"
      :content="`确认删除这条数据需求吗?`"
      :type="2"
      @Del="DelList"
      @confirm="hanleOk"
    >
      <span>确定要删除选中的数据吗？</span>
    </DiaLog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { formatDate } from "@/utils/Date";
import promptMessage from "@/components/promptMessage.vue";
import DiaLog from "@/components/DiaLog.vue";
import { PatchRequierments, DelOneRequierments } from "@/api/file";

export default {
  props: {
    data: Object,
  },
  name: "DataDetail",
  methods: {
    async DelList(){
  const res=   await DelOneRequierments(this.data)
  console.log(res,'res');
  Message({
        type: "success",
        message: "删除成功",
      });
      this.$router.back()
    },
    async RejectOk(e){
      this.isReject=false
    
      
      await PatchRequierments({
        ids: [Number(this.data.id)],
        status: 4,
        reject_reason:e
      });
      Message({
        type: "success",
        message: "驳回成功",
      });
      this.$router.back()
    },
    Reject(){
      this.isReject=true
    },
    getFileName(){
return this.data.attachment_url.split('/').pop()
    },
    async hanleOk() {
      console.log(this.data, "this.data");
      const res = await PatchRequierments({
        ids: [Number(this.data.id)],
        status: 3,
      });
      this.isDel = false;
      this.$router.back();
      Message({
        type: "success",
        message: "发布成功",
      });
    },
    formatDate,
    async handleDel() {
      const res = await PatchRequierments({
        ids: [Number(this.data.id)],
        status: 3,
      });
      this.isDel = false;
      this.$router.back();
      Message({
        type: "success",
        message: "发布成功",
      });
    },
    async Success(data) {
      console.log(data);
      const res = await PatchRequierments({
        ids: [Number(data.id)],
        status: 5,
      });
      Message({
        type: "success",
        message: "已交付成功",
      });
      this.$router.back();
    },
    async DelOne(data) {
   
      this.isDel2=true
      console.log(this.isDel2,'this.isDel2');
      
      return
      const id = { ...data, id: Number(data.id) };
      const res = await DelOneRequierments(id);
      console.log(res, "res");
      Message({
        type: "success",
        message: "删除成功",
      });
      this.$router.back();
    },
    async Shelves(data) {
      console.log(data);
      const res = await PatchRequierments({
        ids: [Number(data.id)],
        status: 6,
      });
      console.log(res, "res");
      Message({
        type: "success",
        message: "下架成功",
      });
      this.$router.back();
    },
    hanleclick() {
      this.isDel = true;
      console.log(this.isDel);
    },
    SetDataOne() {
      this.$router.push({
        path: "SetData",
        query: {
          ...this.data,
        },
      });
    },
    createDemand() {
      
      this.$router.push({
        path: "formalRequirements",
        query: {
          ...this.data,
          
        },
      });
    },
  },
  components: {
    promptMessage,
    DiaLog,
  },
  computed: {
    type() {
      return Number(this.$store.state.type);
    },
  },
  created() {
    console.log(this.data,'1111');
  },
  data() {
    return {
      a: 3,
      isDel: false,
      isReject:false,
      isDel2:false,

    };
  },
};
</script>

<style scoped>
.Button1 {
  cursor: pointer;
}
.Button {
  cursor: pointer;
}
.success {
  height: 30px;
  line-height: 30px;
  width: 80px;
  height: 30px;
  border-color: transparent !important;
  border-radius: 4px;
  font-family: Regular;
  font-size: 14px;
  background-color: #0d53ff;
  color: #fff;
}
.Button1 {
  height: 30px;
  line-height: 30px;
  padding: 0px 12px;
  border-radius: 4px;
  font-family: Regular;
  font-size: 14px;
  background-color: #0d53ff;
  color: #fff;
}
.Del {
  color: #fff;
  background-color: Red;
  border-color: transparent !important ;
}
.Back {
  color: #666666;
  border-color: #e9e9e9 !important;
}
.Button {
  font-family: Regular;
  font-size: 14px;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid #999;
}
.Detail-container {
  background: #fff;
  padding: 32px 48px 24px 48px;

  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}
.back-btn {
  color: #888;
  font-size: 14px;
  margin-bottom: 20px;
  font-family: Medium;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}
.detail-content {
  padding-top: 20px;
  max-width: 700px;
}
.row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 14px;
}
.label {
  width: 84px;
  color: #000;
  font-family: Regular;
  font-size: 14px;
  flex-shrink: 0;
  line-height: 20px;
}
.value {
  color: #666;

  font-family: Regular;
  font-size: 14px;
  line-height: 20px;
  word-break: break-all;
}
.status {
  color: #0d53ff;
}
.industry-tag {
  display: inline-block;
  border-radius: 4px;
  background: rgba(13, 83, 255, 0.12);
  line-height: 24px;
  text-align: center;
  color: #0d53ff;
  border-radius: 4px;
  width: 72px;
  height: 24px;
  font-size: 14px;
}
.attachment-box {
  display: flex;
  align-items: center;
  background: #f7f7f7;
  border-radius: 4px;
  border-radius: 6px;
  padding: 10px 20px;
  width: 320px;
}
.file-icon {
  width: 38px;
  height: 38px;
  margin-right: 12px;
}
.file-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.file-name {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-family: Regular;
  color: #222;
}
.file-size {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-family: Regular;
  color: #999;
}
.download-link {
  color: #0d53ff;
  font-size: 14px;

  text-decoration: none;
  margin-left: 12px;
}
.desc {
  white-space: pre-line;
  color: #444;
  font-size: 14px;
}
.btn-group {
  display: flex;
  margin-left: 84px;
  gap: 18px;
  margin-top: 32px;
}
</style>
